import React, { Component } from 'react';
import { DisplayComponent } from 'formlabs-web-components/BaseComponents';
import { Cell, Grid, Section } from 'formlabs-web-components/Grid';
import { Header } from 'formlabs-web-components/Type';
import {
  TextArea,
  Input,
  Select,
  CheckBox,
  Radio
} from 'formlabs-web-components/Form';
import { Spinner } from 'formlabs-web-components/Navigation';
import classNames from 'classnames';
import './Forms.module.css';
import Cookies from 'js-cookie';
import { withTranslation } from 'react-i18next';
import { analytics } from '../../../../common/utils';
import identifyIntegrations from '../../../../common/components/forms/identifyIntegrations';

const ResellerForm = DisplayComponent(
  class ResellerForm extends Component {
    state = {
      submitting: false,
      success: false,
      error: false
    };
    onFormSubmit = e => {
      e.preventDefault();

      this.setState({ submitting: true, error: false });
      const csrftoken = Cookies.get('csrftoken');
      const form = e.target;
      let form_data = new FormData(form);

      analytics.identify(
        form_data.get('tfa_6'),
        {
          email: form_data.get('tfa_6'),
          firstName: form_data.get('tfa_1'),
          lastName: form_data.get('tfa_122')
        },
        identifyIntegrations
      );
      analytics.track(
        'Become a reseller Form Submitted',
        {
          category: 'Segment',
          email: form_data.get('tfa_6')
        },
        {
          integrations: {
            Marketo: false,
            'Marketo V2': false
          }
        }
      );

      fetch(form.action, {
        method: 'POST',
        body: form_data,
        headers: {
          'X-CSRFToken': csrftoken
        }
      })
        .then(response => this.setState({ success: true, submitting: false }))
        .catch(error => {
          this.setState({ error: true, submitting: false });
        });
    };
    render() {
      const { t, classes } = this.props;
      const { success, submitting, error } = this.state;
      return (
        <form
          action="/form_proxy/"
          className={classNames('reseller-form', 'ga-track', classes)}
          data-ga-action="Submit reseller inquiry"
          id="tfa_0"
          method="POST"
          styleName="resellers-form"
          onSubmit={this.onFormSubmit}
        >
          <div>
            <Input
              id="Campaign_ID"
              name="tfa_138"
              type="hidden"
              value="701i0000000f64K"
            />
            <Input
              id="Referral URL"
              maxLength="255"
              name="tfa_139"
              type="hidden"
              value="https://formlabs.com/"
            />
            <Input
              id="Language Preference"
              maxLength="255"
              name="tfa_140"
              type="hidden"
              value="en"
            />
            <Input id="_mkt_trk" name="_mkt_trk" type="hidden" />
            <Input id="_tfa_mkt_trk" name="tfa_144" type="hidden" />
            <Input id="acquisition_source_first" name="tfa_141" type="hidden" />
            <Input id="acquisition_source_last" name="tfa_142" type="hidden" />
            <Input id="gclid" name="tfa_143" type="hidden" />
            <Input id="utm_campaign_first" name="tfa_170" type="hidden" />
            <Input id="utm_campaign_latest" name="tfa_171" type="hidden" />
          </div>

          <Grid direction="x" gutters="padding">
            <Cell mediumSize={24}>
              <Header level={3} displayAs={3}>
                Personal Information
              </Header>
            </Cell>
            <Cell mediumSize={12}>
              <label htmlFor="first_name">{t('First name')}</label>
              <Input
                id="first_name"
                maxLength="40"
                name="tfa_1"
                required
                size="20"
                type="text"
                aria-label={t('First name')}
              />
            </Cell>
            <Cell mediumSize={12}>
              <label htmlFor="last_name">{t('Last name')}</label>
              <Input
                id="last_name"
                maxLength="80"
                name="tfa_122"
                required
                size="20"
                type="text"
                aria-label={t('Last name')}
              />
            </Cell>
            <Cell mediumSize={12}>
              <label htmlFor="email">{t('Business email')}</label>
              <Input
                id="email"
                maxLength="80"
                name="tfa_6"
                required
                size="20"
                type="email"
              />
            </Cell>
            <Cell mediumSize={12}>
              <label htmlFor="phone">{t('Phone')}</label>
              <Input
                id="phone"
                maxLength="40"
                name="tfa_5"
                required
                size="20"
                type="text"
              />
            </Cell>
            <Cell mediumSize={12}>
              <label htmlFor="job_title">{t('Job Title')}</label>
              <Input
                id="job_title"
                maxLength="80"
                name="tfa_2"
                required
                size="100"
                type="text"
              />
            </Cell>
          </Grid>
          <Section marginBefore="2rem">
            <Grid direction="x" gutters="padding">
              <Cell mediumSize={24}>
                <Header level={3} displayAs={3}>
                  Company Information
                </Header>
              </Cell>
              <Cell mediumSize={12}>
                <label htmlFor="company">{t('Company')}</label>
                <Input
                  id="company"
                  maxLength="80"
                  name="tfa_3"
                  required
                  size="100"
                  type="text"
                />
              </Cell>
              <Cell mediumSize={12}>
                <label htmlFor="company_website">{t('Company Website')}</label>
                <Input
                  id="company_website"
                  maxLength="80"
                  name="tfa_4"
                  required
                  size="100"
                  type="text"
                />
              </Cell>
              <Cell mediumSize={24}>
                <label htmlFor="address">{t('Address')}</label>
                <Input
                  id="address"
                  maxLength="40"
                  name="tfa_7"
                  required
                  size="45"
                  type="text"
                />
              </Cell>
              <Cell mediumSize={12}>
                <label htmlFor="city">{t('City')}</label>
                <Input
                  id="city"
                  maxLength="40"
                  name="tfa_8"
                  required
                  size="45"
                  type="text"
                />
              </Cell>
              <Cell mediumSize={12}>
                <label htmlFor="country">{t('Country')}</label>
                <Select id="country" name="tfa_9" required>
                  <option value="">– {t('Select')} –</option>
                  <option value="Afghanistan">{t('Afghanistan')}</option>
                  <option value="Åland Islands">{t('Åland Islands')}</option>
                  <option value="Albania">{t('Albania')}</option>
                  <option value="Algeria">{t('Algeria')}</option>
                  <option value="Andorra">{t('Andorra')}</option>
                  <option value="Angola">{t('Angola')}</option>
                  <option value="Anguilla">{t('Anguilla')}</option>
                  <option value="Antarctica">{t('Antarctica')}</option>
                  <option value="Antigua and Barbuda">
                    {t('Antigua and Barbuda')}
                  </option>
                  <option value="Argentina">{t('Argentina')}</option>
                  <option value="Armenia">{t('Armenia')}</option>
                  <option value="Aruba">{t('Aruba')}</option>
                  <option value="Australia">{t('Australia')}</option>
                  <option value="Austria">{t('Austria')}</option>
                  <option value="Azerbaijan">{t('Azerbaijan')}</option>
                  <option value="Bahamas">{t('Bahamas')}</option>
                  <option value="Bahrain">{t('Bahrain')}</option>
                  <option value="Bangladesh">{t('Bangladesh')}</option>
                  <option value="Barbados">{t('Barbados')}</option>
                  <option value="Belarus">{t('Belarus')}</option>
                  <option value="Belgium">{t('Belgium')}</option>
                  <option value="Belize">{t('Belize')}</option>
                  <option value="Benin">{t('Benin')}</option>
                  <option value="Bermuda">{t('Bermuda')}</option>
                  <option value="Bhutan">{t('Bhutan')}</option>
                  <option value="Bolivia, Plurinational State of">
                    {t('Bolivia, Plurinational State of')}
                  </option>
                  <option value="Bonaire, Sint Eustatius and Saba">
                    {t('Bonaire, Sint Eustatius and Saba')}
                  </option>
                  <option value="Bosnia and Herzegovina">
                    {t('Bosnia and Herzegovina')}
                  </option>
                  <option value="Botswana">{t('Botswana')}</option>
                  <option value="Bouvet Island">{t('Bouvet Island')}</option>
                  <option value="Brazil">{t('Brazil')}</option>
                  <option value="British Indian Ocean Territory">
                    {t('British Indian Ocean Territory')}
                  </option>
                  <option value="Brunei Darussalam">
                    {t('Brunei Darussalam')}
                  </option>
                  <option value="Bulgaria">{t('Bulgaria')}</option>
                  <option value="Burkina Faso">{t('Burkina Faso')}</option>
                  <option value="Burundi">{t('Burundi')}</option>
                  <option value="Cambodia">{t('Cambodia')}</option>
                  <option value="Cameroon">{t('Cameroon')}</option>
                  <option value="Canada">{t('Canada')}</option>
                  <option value="Cape Verde">{t('Cape Verde')}</option>
                  <option value="Cayman Islands">{t('Cayman Islands')}</option>
                  <option value="Central African Republic">
                    {t('Central African Republic')}
                  </option>
                  <option value="Chad">{t('Chad')}</option>
                  <option value="Chile">{t('Chile')}</option>
                  <option value="China">{t('China')}</option>
                  <option value="Christmas Island">
                    {t('Christmas Island')}
                  </option>
                  <option value="Cocos (Keeling) Islands">
                    {t('Cocos (Keeling) Islands')}
                  </option>
                  <option value="Colombia">{t('Colombia')}</option>
                  <option value="Comoros">{t('Comoros')}</option>
                  <option value="Congo">{t('Congo')}</option>
                  <option value="Congo, the Democratic Republic of the">
                    {t('Congo, the Democratic Republic of the')}
                  </option>
                  <option value="Cook Islands">{t('Cook Islands')}</option>
                  <option value="Costa Rica">{t('Costa Rica')}</option>
                  <option value="Côte d'Ivoire">{t("Côte d'Ivoire")}</option>
                  <option value="Croatia">{t('Croatia')}</option>
                  <option value="Cuba">{t('Cuba')}</option>
                  <option value="Curaçao">{t('Curaçao')}</option>
                  <option value="Cyprus">{t('Cyprus')}</option>
                  <option value="Czech Republic">{t('Czech Republic')}</option>
                  <option value="Denmark">{t('Denmark')}</option>
                  <option value="Djibouti">{t('Djibouti')}</option>
                  <option value="Dominica">{t('Dominica')}</option>
                  <option value="Dominican Republic">
                    {t('Dominican Republic')}
                  </option>
                  <option value="Ecuador">{t('Ecuador')}</option>
                  <option value="Egypt">{t('Egypt')}</option>
                  <option value="El Salvador">{t('El Salvador')}</option>
                  <option value="Equatorial Guinea">
                    {t('Equatorial Guinea')}
                  </option>
                  <option value="Eritrea">{t('Eritrea')}</option>
                  <option value="Estonia">{t('Estonia')}</option>
                  <option value="Ethiopia">{t('Ethiopia')}</option>
                  <option value="Falkland Islands (Malvinas)">
                    {t('Falkland Islands (Malvinas)')}
                  </option>
                  <option value="Faroe Islands">{t('Faroe Islands')}</option>
                  <option value="Fiji">{t('Fiji')}</option>
                  <option value="Finland">{t('Finland')}</option>
                  <option value="France">{t('France')}</option>
                  <option value="French Guiana">{t('French Guiana')}</option>
                  <option value="French Polynesia">
                    {t('French Polynesia')}
                  </option>
                  <option value="French Southern Territories">
                    {t('French Southern Territories')}
                  </option>
                  <option value="Gabon">{t('Gabon')}</option>
                  <option value="Gambia">{t('Gambia')}</option>
                  <option value="Georgia">{t('Georgia')}</option>
                  <option value="Germany">{t('Germany')}</option>
                  <option value="Ghana">{t('Ghana')}</option>
                  <option value="Gibraltar">{t('Gibraltar')}</option>
                  <option value="Greece">{t('Greece')}</option>
                  <option value="Greenland">{t('Greenland')}</option>
                  <option value="Grenada">{t('Grenada')}</option>
                  <option value="Guadeloupe">{t('Guadeloupe')}</option>
                  <option value="Guatemala">{t('Guatemala')}</option>
                  <option value="Guernsey">{t('Guernsey')}</option>
                  <option value="Guinea">{t('Guinea')}</option>
                  <option value="Guinea-Bissau">{t('Guinea-Bissau')}</option>
                  <option value="Guyana">{t('Guyana')}</option>
                  <option value="Haiti">{t('Haiti')}</option>
                  <option value="Heard Island and McDonald Islands">
                    {t('Heard Island and McDonald Islands')}
                  </option>
                  <option value="Holy See (Vatican City State)">
                    {t('Holy See (Vatican City State)')}
                  </option>
                  <option value="Honduras">{t('Honduras')}</option>
                  <option value="Hong Kong">{t('Hong Kong')}</option>
                  <option value="Hungary">{t('Hungary')}</option>
                  <option value="Iceland">{t('Iceland')}</option>
                  <option value="India">{t('India')}</option>
                  <option value="Indonesia">{t('Indonesia')}</option>
                  <option value="Iran, Islamic Republic of">
                    {t('Iran, Islamic Republic of')}
                  </option>
                  <option value="Iraq">{t('Iraq')}</option>
                  <option value="Ireland">{t('Ireland')}</option>
                  <option value="Isle of Man">{t('Isle of Man')}</option>
                  <option value="Israel">{t('Israel')}</option>
                  <option value="Italy">{t('Italy')}</option>
                  <option value="Jamaica">{t('Jamaica')}</option>
                  <option value="Japan">{t('Japan')}</option>
                  <option value="Jersey">{t('Jersey')}</option>
                  <option value="Jordan">{t('Jordan')}</option>
                  <option value="Kazakhstan">{t('Kazakhstan')}</option>
                  <option value="Kenya">{t('Kenya')}</option>
                  <option value="Kiribati">{t('Kiribati')}</option>
                  <option value="Korea, Democratic People's Republic of">
                    {t("Korea, Democratic People's Republic of")}
                  </option>
                  <option value="Korea, Republic of">{t('Korea')}</option>
                  <option value="Kuwait">{t('Kuwait')}</option>
                  <option value="Kyrgyzstan">{t('Kyrgyzstan')}</option>
                  <option value="Lao People's Democratic Republic">
                    {t("Lao People's Democratic Republic")}
                  </option>
                  <option value="Latvia">{t('Latvia')}</option>
                  <option value="Lebanon">{t('Lebanon')}</option>
                  <option value="Lesotho">{t('Lesotho')}</option>
                  <option value="Liberia">{t('Liberia')}</option>
                  <option value="Libya">{t('Libya')}</option>
                  <option value="Liechtenstein">{t('Liechtenstein')}</option>
                  <option value="Lithuania">{t('Lithuania')}</option>
                  <option value="Luxembourg">{t('Luxembourg')}</option>
                  <option value="Macao">{t('Macao')}</option>
                  <option value="Macedonia, the former Yugoslav Republic of">
                    {t('Macedonia, the former Yugoslav Republic of')}
                  </option>
                  <option value="Madagascar">{t('Madagascar')}</option>
                  <option value="Malawi">{t('Malawi')}</option>
                  <option value="Malaysia">{t('Malaysia')}</option>
                  <option value="Maldives">{t('Maldives')}</option>
                  <option value="Mali">{t('Mali')}</option>
                  <option value="Malta">{t('Malta')}</option>
                  <option value="Martinique">{t('Martinique')}</option>
                  <option value="Mauritania">{t('Mauritania')}</option>
                  <option value="Mauritius">{t('Mauritius')}</option>
                  <option value="Mayotte">{t('Mayotte')}</option>
                  <option value="Mexico">{t('Mexico')}</option>
                  <option value="Moldova, Republic of">
                    {t('Moldova, Republic of')}
                  </option>
                  <option value="Monaco">{t('Monaco')}</option>
                  <option value="Mongolia">{t('Mongolia')}</option>
                  <option value="Montenegro">{t('Montenegro')}</option>
                  <option value="Montserrat">{t('Montserrat')}</option>
                  <option value="Morocco">{t('Morocco')}</option>
                  <option value="Mozambique">{t('Mozambique')}</option>
                  <option value="Myanmar">{t('Myanmar')}</option>
                  <option value="Namibia">{t('Namibia')}</option>
                  <option value="Nauru">{t('Nauru')}</option>
                  <option value="Nepal">{t('Nepal')}</option>
                  <option value="Netherlands">{t('Netherlands')}</option>
                  <option value="New Caledonia">{t('New Caledonia')}</option>
                  <option value="New Zealand">{t('New Zealand')}</option>
                  <option value="Nicaragua">{t('Nicaragua')}</option>
                  <option value="Niger">{t('Niger')}</option>
                  <option value="Nigeria">{t('Nigeria')}</option>
                  <option value="Niue">{t('Niue')}</option>
                  <option value="Norfolk Island">{t('Norfolk Island')}</option>
                  <option value="Norway">{t('Norway')}</option>
                  <option value="Oman">{t('Oman')}</option>
                  <option value="Pakistan">{t('Pakistan')}</option>
                  <option value="Palestine, State of">
                    {t('Palestine, State of')}
                  </option>
                  <option value="Panama">{t('Panama')}</option>
                  <option value="Papua New Guinea">
                    {t('Papua New Guinea')}
                  </option>
                  <option value="Paraguay">{t('Paraguay')}</option>
                  <option value="Peru">{t('Peru')}</option>
                  <option value="Philippines">{t('Philippines')}</option>
                  <option value="Pitcairn">{t('Pitcairn')}</option>
                  <option value="Poland">{t('Poland')}</option>
                  <option value="Portugal">{t('Portugal')}</option>
                  <option value="Qatar">{t('Qatar')}</option>
                  <option value="Réunion">{t('Réunion')}</option>
                  <option value="Romania">{t('Romania')}</option>
                  <option value="Russian Federation">
                    {t('Russian Federation')}
                  </option>
                  <option value="Rwanda">{t('Rwanda')}</option>
                  <option value="Saint Barthélemy">
                    {t('Saint Barthélemy')}
                  </option>
                  <option value="Saint Helena, Ascension and Tristan da Cunha">
                    {t('Saint Helena, Ascension and Tristan da Cunha')}
                  </option>
                  <option value="Saint Kitts and Nevis">
                    Saint Kitts and Nevis
                  </option>
                  <option value="Saint Lucia">{t('Saint Lucia')}</option>
                  <option value="Saint Martin (French part)">
                    {t('Saint Martin (French part)')}
                  </option>
                  <option value="Saint Pierre and Miquelon">
                    {t('Saint Pierre and Miquelon')}
                  </option>
                  <option value="Saint Vincent and the Grenadines">
                    {t('Saint Vincent and the Grenadines')}
                  </option>
                  <option value="Samoa">{t('Samoa')}</option>
                  <option value="San Marino">{t('San Marino')}</option>
                  <option value="Sao Tome and Principe">
                    {t('Sao Tome and Principe')}
                  </option>
                  <option value="Saudi Arabia">{t('Saudi Arabia')}</option>
                  <option value="Senegal">{t('Senegal')}</option>
                  <option value="Serbia">{t('Serbia')}</option>
                  <option value="Seychelles">{t('Seychelles')}</option>
                  <option value="Sierra Leone">{t('Sierra Leone')}</option>
                  <option value="Singapore">{t('Singapore')}</option>
                  <option value="Sint Maarten (Dutch part)">
                    {t('Sint Maarten (Dutch part)')}
                  </option>
                  <option value="Slovakia">{t('Slovakia')}</option>
                  <option value="Slovenia">{t('Slovenia')}</option>
                  <option value="Solomon Islands">
                    {t('Solomon Islands')}
                  </option>
                  <option value="Somalia">{t('Somalia')}</option>
                  <option value="South Africa">{t('South Africa')}</option>
                  <option value="South Georgia and the South Sandwich Islands">
                    {t('South Georgia and the South Sandwich Islands')}
                  </option>
                  <option value="South Sudan">{t('South Sudan')}</option>
                  <option value="Spain">{t('Spain')}</option>
                  <option value="Sri Lanka">{t('Sri Lanka')}</option>
                  <option value="Sudan">{t('Sudan')}</option>
                  <option value="Suriname">{t('Suriname')}</option>
                  <option value="Svalbard and Jan Mayen">
                    {t('Svalbard and Jan Mayen')}
                  </option>
                  <option value="Swaziland">{t('Swaziland')}</option>
                  <option value="Sweden">{t('Sweden')}</option>
                  <option value="Switzerland">{t('Switzerland')}</option>
                  <option value="Syrian Arab Republic">
                    {t('Syrian Arab Republic')}
                  </option>
                  <option value="Taiwan">{t('Taiwan')}</option>
                  <option value="Tajikistan">{t('Tajikistan')}</option>
                  <option value="Tanzania, United Republic of">
                    {t('Tanzania, United Republic of')}
                  </option>
                  <option value="Thailand">{t('Thailand')}</option>
                  <option value="Timor-Leste">{t('Timor-Leste')}</option>
                  <option value="Togo">{t('Togo')}</option>
                  <option value="Tokelau">{t('Tokelau')}</option>
                  <option value="Tonga">{t('Tonga')}</option>
                  <option value="Trinidad and Tobago">
                    {t('Trinidad and Tobago')}
                  </option>
                  <option value="Tunisia">{t('Tunisia')}</option>
                  <option value="Turkey">{t('Turkey')}</option>
                  <option value="Turkmenistan">{t('Turkmenistan')}</option>
                  <option value="Turks and Caicos Islands">
                    {t('Turks and Caicos Islands')}
                  </option>
                  <option value="Tuvalu">{t('Tuvalu')}</option>
                  <option value="Uganda">{t('Uganda')}</option>
                  <option value="Ukraine">{t('Ukraine')}</option>
                  <option value="United Arab Emirates">
                    {t('United Arab Emirates')}
                  </option>
                  <option value="United Kingdom">{t('United Kingdom')}</option>
                  <option value="United States">{t('United States')}</option>
                  <option value="Uruguay">{t('Uruguay')}</option>
                  <option value="Uzbekistan">{t('Uzbekistan')}</option>
                  <option value="Vanuatu">{t('Vanuatu')}</option>
                  <option value="Venezuela, Bolivarian Republic of">
                    {t('Venezuela, Bolivarian Republic of')}
                  </option>
                  <option value="Viet Nam">{t('Viet Nam')}</option>
                  <option value="Virgin Islands, British">
                    {t('Virgin Islands, British')}
                  </option>
                  <option value="Wallis and Futuna">
                    {t('Wallis and Futuna')}
                  </option>
                  <option value="Western Sahara">{t('Western Sahara')}</option>
                  <option value="Yemen">{t('Yemen')}</option>
                  <option value="Zambia">{t('Zambia')}</option>
                  <option value="Zimbabwe">{t('Zimbabwe')}</option>
                </Select>
              </Cell>
              <Cell mediumSize={12}>
                <label htmlFor="employees">{t('Number of employees')}</label>
                <Select id="employees" name="tfa_123" required>
                  <option value="">– {t('Select')} –</option>
                  <option value="1-5">1-5</option>
                  <option value="6-15">6-15</option>
                  <option value="16-50">16-50</option>
                  <option value="51-100">51-100</option>
                  <option value="100-500">100-500</option>
                  <option value="500+">500+</option>
                </Select>
              </Cell>
              <Cell mediumSize={12}>
                <label htmlFor="annual_revenue">
                  {t('Annual revenue in USD')}
                </label>
                <Select id="annual_revenue" name="tfa_124" required>
                  <option value="">– {t('Select')} –</option>
                  <option value="$100,000">{t('Less than $100,000')}</option>
                  <option value="$100,000-$500,000">
                    {t('$100,000 - $500,000')}
                  </option>
                  <option value="$500,000-$1,000,000">
                    {t('$500,000 - $1,000,000')}
                  </option>
                  <option value="$1,000,000-$10,000,000">
                    {t('$1,000,000 - $10,000,000')}
                  </option>
                  <option value="$10,000,000-$100,000,000">
                    {t('$10,000,000 - $100,000,000')}
                  </option>
                  <option value="$100,000,000+">{t('$100,000,000+')}</option>
                </Select>
              </Cell>
              <Cell mediumSize={24}>
                <label htmlFor="countries_served">
                  {t('Which countries do you serve?')}
                </label>
                <TextArea
                  id="countries_served"
                  name="tfa_126"
                  required
                  rows="3"
                  type="text"
                  wrap="soft"
                />
              </Cell>
            </Grid>
          </Section>
          <Section marginBefore="2rem">
            <Grid direction="x" gutters="padding">
              <Cell mediumSize={24}>
                <Header level={3} displayAs={3}>
                  Product Offerings
                </Header>
              </Cell>

              <Cell largeSize={12}>
                <div className="checkbox-group required multiple">
                  <label>{t('Are you a current 3D printer reseller?')}</label>
                  <Input name="tfa_131" type="hidden" value="" />
                  <div>
                    <CheckBox id="sla" value="SLA">
                      {t('SLA')}
                    </CheckBox>
                  </div>

                  <div>
                    <CheckBox id="sls" value="SLS">
                      {t('SLS')}
                    </CheckBox>
                  </div>

                  <div>
                    <CheckBox id="dmls" value="DMLS">
                      {t('DMLS')}
                    </CheckBox>
                  </div>

                  <div>
                    <CheckBox id="polyjet" value="Polyjet">
                      {t('Polyjet')}
                    </CheckBox>
                  </div>

                  <CheckBox id="no_3d_printers" value="No">
                    {t('No, we do not sell 3D printers')}
                  </CheckBox>

                  <Grid direction="x" gutters="padding">
                    <Cell smallSize={8}>
                      <CheckBox
                        id="other_3d_printers"
                        name="tfa_131"
                        value="Other"
                      >
                        {t('Other')}
                      </CheckBox>
                    </Cell>
                    <Cell smallSize={16}>
                      <Input
                        id="other_3d_printers_text"
                        name="tfa_147"
                        type="text"
                        aria-label={t('Text entry field for other 3d printers')}
                      />
                    </Cell>
                  </Grid>
                </div>
              </Cell>
              <Cell mediumSize={12}>
                <label htmlFor="key_brands">
                  {t('What are your key brands and models for 3D printers?')}
                </label>
                <TextArea
                  id="key_brands"
                  name="tfa_127"
                  required
                  rows="3"
                  type="text"
                  wrap="soft"
                />
              </Cell>
              <Cell mediumSize={24}>
                <Section marginBefore="3rem">
                  <Grid direction="x" gutters="padding">
                    <Cell largeSize={12}>
                      <label>
                        {t('Do you service 3D printers? Which technologies?')}
                      </label>
                      <Grid direction="x" gutters="padding">
                        <Cell smallSize={8}>
                          <Radio id="yes" name="tfa_133" required value="Yes">
                            {t('Yes')}
                          </Radio>
                        </Cell>
                        <Cell smallSize={16}>
                          <Input
                            id="yes-fill"
                            name="tfa_153"
                            type="text"
                            aria-label={t('Details about printers serviced')}
                          />
                        </Cell>
                        <Cell smallSize={24}>
                          <Radio id="no" name="tfa_133" value="No">
                            {t('No, we do not service')}
                          </Radio>
                        </Cell>
                      </Grid>
                    </Cell>
                    <Cell largeSize={12}>
                      <label>
                        {t(
                          'Do you sell, install or service other type of industrial systems such as CNC, milling machines etc.? Which kind of systems?'
                        )}
                      </label>
                      <div className="checkbox-group required multiple">
                        <Input name="tfa_156" type="hidden" value="" />
                        <Grid direction="x" gutters="padding">
                          <Cell smallSize={8}>
                            <CheckBox id="sell" value="Sell">
                              {t('Sell')}
                            </CheckBox>
                          </Cell>
                          <Cell smallSize={16}>
                            <Input
                              id="sell-fill"
                              name="tfa_154"
                              type="text"
                              aria-label={t(
                                'Types of 3d printing systems you sell'
                              )}
                            />
                          </Cell>
                        </Grid>
                        <Grid direction="x" gutters="padding">
                          <Cell smallSize={8}>
                            <CheckBox id="install" value="Install">
                              {t('Install')}
                            </CheckBox>
                          </Cell>
                          <Cell smallSize={16}>
                            <Input
                              id="install-fill"
                              name="tfa_155"
                              type="text"
                              aria-label={t(
                                'Types of 3d printing systems you install'
                              )}
                            />
                          </Cell>
                        </Grid>
                        <Grid direction="x" gutters="padding">
                          <Cell smallSize={8}>
                            <CheckBox id="service" value="Service">
                              {t('Service')}
                            </CheckBox>
                          </Cell>
                          <Cell smallSize={16}>
                            <Input
                              id="service-fill"
                              name="tfa_134"
                              type="text"
                              aria-label={t(
                                'Types of 3d printing systems you service'
                              )}
                            />
                          </Cell>
                        </Grid>
                      </div>
                    </Cell>
                  </Grid>
                </Section>
              </Cell>
              <Cell mediumSize={24}>
                <Section marginBefore="3rem">
                  <Grid direction="x" gutters="padding">
                    <Cell mediumSize={12}>
                      <label htmlFor="large_format_hardware">
                        {t(
                          'Do you service other large format hardware? If so what kind of equipment and to what extend (Large format 2D printers etc.)?'
                        )}
                      </label>
                      <TextArea
                        id="large_format_hardware"
                        name="tfa_128"
                        required
                        rows="3"
                        type="text"
                        wrap="soft"
                      />
                    </Cell>
                    <Cell mediumSize={12}>
                      <label htmlFor="complementary_products">
                        {t(
                          'Do you sell other complementary products to additive manufacturing such as CAD software etc.? Please list your key products'
                        )}
                      </label>
                      <TextArea
                        id="complementary_products"
                        name="tfa_129"
                        required
                        rows="3"
                        type="text"
                        wrap="soft"
                      />
                    </Cell>
                  </Grid>
                </Section>
              </Cell>
              <Cell mediumSize={24}>
                <Section marginBefore="3rem">
                  <Grid direction="x" gutters="padding">
                    <Cell mediumSize={12}>
                      <label htmlFor="formlabs_printer">
                        {t(
                          'Which Formlabs printer are you most interested in reselling?'
                        )}
                      </label>
                      <Select id="formlabs_printer" name="tfa_125" required>
                        <option value="">– {t('Select')} –</option>
                        <option value="Form 2">{t('Form 2')}</option>
                        <option value="Fuse 1">{t('Fuse 1')}</option>
                        <option value="Both">{t('Both')}</option>
                      </Select>
                    </Cell>
                  </Grid>
                </Section>
              </Cell>
            </Grid>
          </Section>

          <Section marginBefore="2rem">
            <Grid direction="x" gutters="padding">
              <Cell mediumSize={24}>
                <Header level={3} displayAs={3}>
                  Staff
                </Header>
              </Cell>

              <Cell largeSize={12}>
                <label>
                  {t(
                    'Please list the number of dedicated and fully trained staff for the following services? Put zero if you do not provide the service'
                  )}
                </label>
                <Grid direction="x" gutters="padding">
                  <Cell smallSize={12}>
                    <label className="right inline" htmlFor="right-label">
                      {t('Engineering/Product Design')}
                    </label>
                  </Cell>
                  <Cell smallSize={12}>
                    <Input
                      id="engineering_product_design_reps2"
                      name="tfa_136"
                      required
                      type="text"
                      aria-label={t(
                        'Number of staff members who are in Engineering/Product Design roles'
                      )}
                    />
                  </Cell>
                </Grid>
                <Grid direction="x" gutters="padding">
                  <Cell smallSize={12}>
                    <label className="right inline" htmlFor="right-label">
                      {t('Sales')}
                    </label>
                  </Cell>
                  <Cell smallSize={12}>
                    <Input
                      id="sales_reps"
                      name="tfa_157"
                      required
                      type="text"
                      aria-label={t(
                        'Number of staff members who are in sales roles'
                      )}
                    />
                  </Cell>
                </Grid>
                <Grid direction="x" gutters="padding">
                  <Cell smallSize={12}>
                    <label className="right inline" htmlFor="right-label">
                      {t('Marketing')}
                    </label>
                  </Cell>
                  <Cell smallSize={12}>
                    <Input
                      id="marketing_reps"
                      name="tfa_158"
                      required
                      type="text"
                      aria-label={t(
                        'Number of staff members who are in marketing roles'
                      )}
                    />
                  </Cell>
                </Grid>
                <Grid direction="x" gutters="padding">
                  <Cell smallSize={12}>
                    <label className="right inline" htmlFor="right-label">
                      {t('Tech Support')}
                    </label>
                  </Cell>
                  <Cell smallSize={12}>
                    <Input
                      id="tech_support_reps"
                      name="tfa_159"
                      required
                      type="text"
                      aria-label={t(
                        'Number of staff members who are in tech support roles'
                      )}
                    />
                  </Cell>
                </Grid>
                <Grid direction="x" gutters="padding">
                  <Cell smallSize={12}>
                    <label className="right inline" htmlFor="right-label">
                      {t('Shipping and fulfillment')}
                    </label>
                  </Cell>
                  <Cell smallSize={12}>
                    <Input
                      id="shipping_fulfillment_reps"
                      name="tfa_160"
                      required
                      type="text"
                      aria-label={t(
                        'Number of staff members who are in shipping and fulfillment roles'
                      )}
                    />
                  </Cell>
                </Grid>
                <Grid direction="x" gutters="padding">
                  <Cell smallSize={12}>
                    <label className="right inline" htmlFor="right-label">
                      {t('Repair and Refurbishment')}
                    </label>
                  </Cell>
                  <Cell smallSize={12}>
                    <Input
                      id="repair_refurbishment_reps"
                      name="tfa_161"
                      required
                      type="text"
                      aria-label={t(
                        'Number of staff members who are in repair and refurbishment roles'
                      )}
                    />
                  </Cell>
                </Grid>
                <Grid direction="x" gutters="padding">
                  <Cell smallSize={12}>
                    <label className="right inline" htmlFor="right-label">
                      {t('Translation and Localization')}
                    </label>
                  </Cell>
                  <Cell smallSize={12}>
                    <Input
                      id="translation_localization_reps"
                      name="tfa_162"
                      required
                      type="text"
                      aria-label={t(
                        'Number of staff members who are in translation and localization roles'
                      )}
                    />
                  </Cell>
                </Grid>
              </Cell>
              <Cell largeSize={12}>
                <label>
                  {t(
                    'Please give the number of sales reps fully trained on the following technologies? Enter zero if none'
                  )}
                </label>
                <Grid direction="x" gutters="padding">
                  <Cell smallSize={12}>
                    <label className="right inline" htmlFor="right-label">
                      {t('Engineering/Product Design')}
                    </label>
                  </Cell>
                  <Cell smallSize={12}>
                    <Input
                      id="engineering_product_design_reps"
                      name="tfa_135"
                      required
                      type="text"
                      aria-label={t(
                        'Number of staff members who are in Engineering/Product Design roles'
                      )}
                    />
                  </Cell>
                </Grid>
                <Grid direction="x" gutters="padding">
                  <Cell smallSize={12}>
                    <label className="right inline" htmlFor="right-label">
                      {t('AM technologies')}
                    </label>
                  </Cell>
                  <Cell smallSize={12}>
                    <Input
                      id="am_technologies_reps"
                      name="tfa_163"
                      required
                      type="text"
                      aria-label={t(
                        'Number of staff members who are in AM technology roles'
                      )}
                    />
                  </Cell>
                </Grid>
                <Grid direction="x" gutters="padding">
                  <Cell smallSize={12}>
                    <label className="right inline" htmlFor="right-label">
                      {t('CAD Software')}
                    </label>
                  </Cell>
                  <Cell smallSize={12}>
                    <Input
                      id="cad_software_reps"
                      name="tfa_164"
                      required
                      type="text"
                      aria-label={t(
                        'Number of staff members who are in CAD Software roles'
                      )}
                    />
                  </Cell>
                </Grid>
                <Grid direction="x" gutters="padding">
                  <Cell smallSize={12}>
                    <label className="right inline" htmlFor="right-label">
                      {t('Machinery and tooling')}
                    </label>
                  </Cell>
                  <Cell smallSize={12}>
                    <Input
                      id="machinery_tooling_reps"
                      name="tfa_165"
                      required
                      type="text"
                      aria-label={t(
                        'Number of staff members who are in machinery and tooling roles'
                      )}
                    />
                  </Cell>
                </Grid>
              </Cell>
            </Grid>
          </Section>
          <Section marginBefore="2rem">
            <Grid direction="x" gutters="padding">
              <Cell mediumSize={24}>
                <Header level={3} displayAs={3}>
                  Audience
                </Header>
              </Cell>
              <Cell largeSize={12}>
                <div className="checkbox-group required multiple">
                  <label>{t('Target Market Verticals')}</label>
                  <Input name="tfa_130" type="hidden" value="" />
                  <div>
                    <CheckBox
                      id="engineering_product_design_vertical"
                      value="Engineering/Product Design"
                    >
                      {t('Engineering/Product Design')}
                    </CheckBox>
                  </div>

                  <div>
                    <CheckBox id="manufacturing_vertical" value="Manufacturing">
                      {t('Manufacturing')}
                    </CheckBox>
                  </div>

                  <div>
                    <CheckBox id="education_vertical" value="Education">
                      {t('Education')}
                    </CheckBox>
                  </div>

                  <div>
                    <CheckBox id="jewelry_vertical" value="Jewelry">
                      {t('Jewelry')}
                    </CheckBox>
                  </div>

                  <CheckBox id="dentistry_vertical" value="Dentistry">
                    {t('Dentistry')}
                  </CheckBox>

                  <Grid direction="x" gutters="padding">
                    <Cell smallSize={8}>
                      <CheckBox id="other_vertical" value="Other">
                        {t('Other')}
                      </CheckBox>
                    </Cell>
                    <Cell smallSize={16}>
                      <Input
                        id="other_vertical_text"
                        name="tfa_146"
                        type="text"
                        aria-label={t('Other target market verticals')}
                      />
                    </Cell>
                  </Grid>
                </div>
              </Cell>

              <Cell largeSize={12}>
                <label>
                  {t(
                    'Approximately what percentage of your customers or revenue come from the following verticals? Please enter zero if none'
                  )}
                </label>
                <Grid direction="x" gutters="padding">
                  <Cell smallSize={12}>
                    <label className="right inline" htmlFor="right-label">
                      {t('Engineering/Product Design')}
                    </label>
                  </Cell>
                  <Cell smallSize={12}>
                    <Grid direction="x">
                      <Cell smallSize={18}>
                        <Input
                          id="engineering_product_design_percentage"
                          name="tfa_132"
                          required
                          type="text"
                          aria-label={t(
                            'Percentage of customers or revenue who come from engineering and product design'
                          )}
                        />
                      </Cell>
                      <Cell smallSize={6}>
                        <span styleName="postfix">%</span>
                      </Cell>
                    </Grid>
                  </Cell>
                </Grid>
                <Grid direction="x" gutters="padding">
                  <Cell smallSize={12}>
                    <label className="right inline" htmlFor="right-label">
                      {t('Manufacturing')}
                    </label>
                  </Cell>
                  <Cell smallSize={12}>
                    <Grid direction="x">
                      <Cell smallSize={18}>
                        <Input
                          id="manufacturing_percentage"
                          name="tfa_148"
                          required
                          type="text"
                          aria-label={t(
                            'Percentage of customers or revenue who come from manufacturing design'
                          )}
                        />
                      </Cell>
                      <Cell smallSize={6}>
                        <span styleName="postfix">%</span>
                      </Cell>
                    </Grid>
                  </Cell>
                </Grid>
                <Grid direction="x" gutters="padding">
                  <Cell smallSize={12}>
                    <label className="right inline" htmlFor="right-label">
                      {t('Education')}
                    </label>
                  </Cell>
                  <Cell smallSize={12}>
                    <Grid direction="x">
                      <Cell smallSize={18}>
                        <Input
                          id="education_percentage"
                          name="tfa_149"
                          required
                          type="text"
                          aria-label={t(
                            'Percentage of customers or revenue who come from education'
                          )}
                        />
                      </Cell>
                      <Cell smallSize={6}>
                        <span styleName="postfix">%</span>
                      </Cell>
                    </Grid>
                  </Cell>
                </Grid>
                <Grid direction="x" gutters="padding">
                  <Cell smallSize={12}>
                    <label className="right inline" htmlFor="right-label">
                      {t('Jewelry')}
                    </label>
                  </Cell>
                  <Cell smallSize={12}>
                    <Grid direction="x">
                      <Cell smallSize={18}>
                        <Input
                          id="jewelry_percentage"
                          name="tfa_150"
                          required
                          type="text"
                          aria-label={t(
                            'Percentage of customers or revenue who come from jewelry design'
                          )}
                        />
                      </Cell>
                      <Cell smallSize={6}>
                        <span styleName="postfix">%</span>
                      </Cell>
                    </Grid>
                  </Cell>
                </Grid>
                <Grid direction="x" gutters="padding">
                  <Cell smallSize={12}>
                    <label className="right inline" htmlFor="right-label">
                      {t('Dentistry')}
                    </label>
                  </Cell>
                  <Cell smallSize={12}>
                    <Grid direction="x">
                      <Cell smallSize={18}>
                        <Input
                          id="dentistry_percentage"
                          name="tfa_151"
                          required
                          type="text"
                          aria-label={t(
                            'Percentage of customers or revenue who come from dentistry'
                          )}
                        />
                      </Cell>
                      <Cell smallSize={6}>
                        <span styleName="postfix">%</span>
                      </Cell>
                    </Grid>
                  </Cell>
                </Grid>
                <Grid direction="x" gutters="padding">
                  <Cell smallSize={12}>
                    <label className="right inline" htmlFor="right-label">
                      {t('Other')}
                    </label>
                  </Cell>
                  <Cell smallSize={12}>
                    <Grid direction="x">
                      <Cell smallSize={18}>
                        <Input
                          id="other_percentage"
                          name="tfa_152"
                          required
                          type="text"
                          aria-label={t(
                            'Percentage of customers or revenue who come from other fields'
                          )}
                        />
                      </Cell>
                      <Cell smallSize={6}>
                        <span styleName="postfix">%</span>
                      </Cell>
                    </Grid>
                  </Cell>
                </Grid>
              </Cell>
            </Grid>
          </Section>
          <Grid direction="x" gutters="padding">
            <Cell mediumSize={24}>
              <label htmlFor="other_information">
                {t(
                  'Any other information about your business that you would like to provide (optional)'
                )}
              </label>
              <TextArea
                id="other_information"
                name="tfa_137"
                rows="3"
                type="text"
                wrap="soft"
              />
            </Cell>
          </Grid>
          <Grid direction="x" gutters="padding">
            <Cell mediumSize={24}>
              {!submitting && !success && (
                <Input styleName="button" type="submit" value={t('Submit')} />
              )}
              {success && (
                <p>
                  {t(
                    "Thank you for showing your interest in becoming a Formlabs Reseller. We'll be in touch shortly."
                  )}
                </p>
              )}
              {submitting && <Spinner size={5} />}
              {error && (
                <p styleName="error">
                  {t(
                    'There was an error submitting your request. Please try again!'
                  )}
                </p>
              )}
              <Input
                id="tfa_dbFormId"
                name="tfa_dbFormId"
                type="hidden"
                value="4620113"
              />
              <Input
                id="tfa_dbResponseId"
                name="tfa_dbResponseId"
                type="hidden"
                value=""
              />
              <Input
                id="tfa_dbControl"
                name="tfa_dbControl"
                type="hidden"
                value="4e3d03f5cbd3e44dc8b7310139012a73"
              />
              <Input
                id="tfa_dbVersionId"
                name="tfa_dbVersionId"
                type="hidden"
                value="15"
              />
              <Input
                id="tfa_switchedoff"
                name="tfa_switchedoff"
                type="hidden"
                value=""
              />
            </Cell>
          </Grid>
        </form>
      );
    }
  }
);

export default withTranslation()(ResellerForm);
